/* -------------------------------- Imports --------------------------------- */
/* ------------------------------ Definitions ------------------------------- */
/* ------------------------------- Functions -------------------------------- */
const constants = {
  projectNames: {
    bestPractices: 'BEST_PRACTICES',
    patientSafety: 'PATIENT_SAFETY'
  }
}

/* --------------------------------- Body ----------------------------------- */
/* -------------------------------- Exports --------------------------------- */
export default constants



// WEBPACK FOOTER //
// ./src/services/Constants.js